import type { CardProfileEntity } from "src/app/features/ApplicationProfile/subFeatures/CardProfile/types/CardProfileEntity";
import type { CardTypeEntity } from "src/app/features/CardType/types/CardTypeEntity";
import { deepClone } from "../../../core/utils/utilFunctions";

export const updateWatchedFieldsUtils = (cardTypeEntity: CardTypeEntity, formData: CardProfileEntity, updateFields: string[]) => {
    const newFormData = deepClone(formData);

    // set field values from parent
    for (const fieldName of updateFields ?? []) {
        newFormData[fieldName] = fieldName === "authCardTypeId" ? cardTypeEntity.code : cardTypeEntity[fieldName as keyof CardTypeEntity];
    }

    // set readOnly fields
    for (const fieldName of updateFields ?? []) {
        const readOnlyKey = `${fieldName}CheckReadOnly`;
        const entityKey = fieldName === "authCardTypeId" ? "codeRO" : `${fieldName}RO`;
        newFormData[readOnlyKey] = cardTypeEntity?.[entityKey as keyof CardTypeEntity];
    }

    // HANDLE DYNAMIC PROPERTIES
    const dynamicPropertiesList = cardTypeEntity?.dynamicProperties?.dynamicPropertyValues || [];
    newFormData.dynamicProperties = {
        dynamicPropertyGroupValue: cardTypeEntity?.dynamicProperties?.dynamicPropertyGroupValue,
        dynamicPropertyValues: dynamicPropertiesList.map(({ id: _id, ...rest }) => {
            return {
                id: _id,
                ...rest,
            };
        }),
    };

    return newFormData;
};
